// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"14ad3048","745":"0be52095","776":"b111abb4","976":"95a67d67"}[chunkId] + ".chunk.css";
};